// import React from 'react';
import * as am4core from "@amcharts/amcharts4/core";

import { CATEGORY_COLOR_SET, SENTIMENT_COLOR_SET } from "../../../config/ColorSet";
import { CATEGORY_SET } from '../../../config/CategorySet';


const JSONtoChartData = ({data, index, type}) => {
  const dataSet = data;
  // console.log(data)
  const dataType = type;
  const dataIndex = index;
  let retDataSet = [];

  switch (dataType) {
    case "sparkLine": {
      dataSet['keyword-frequency-list'].forEach((item)=>{
        retDataSet.push({
          "date": item['date'],
          "value": item['sum-frequency']
        })
      })
      break;
    }
    case "keywordWithRank": {
      retDataSet.push({
        "keyword": dataSet['keyword'],
        "rank": dataIndex
      })
      break;
    }
    case "quick-result-relationMap": {
      for(let i = 0; i < dataSet.relation.length; i++){
        retDataSet.push({
          text: dataSet.relation[i].keyword,
          value:dataSet.relation[i].count
        })
        if(i+1 == dataSet.maxWords) break;
      }
      break;
    }
    case "relationMap": {
      let relationWordList =[];
      let keywordValue = 0;
      dataSet['relation-list'].forEach((item)=>{
        if (item['relation-frequency'] > keywordValue) {
          keywordValue = item['relation-frequency']
        }
        relationWordList.push({
          "name": item['relation-word'],
          "value": item['relation-frequency'],
          "category": item['relation-category'],
          "color": am4core.color(CATEGORY_COLOR_SET[item['relation-category']])
        })
      })
      retDataSet.push({
        "name": dataSet['keyword'],
        "children": relationWordList,
        "value": keywordValue,
        "color": am4core.color(CATEGORY_COLOR_SET[dataSet['keyword-category']])
      })
      break;
    }
    case "quick-result-categoryMap": {
      let maxNode = 3;
      let relationWordList = [];
            
      retDataSet.push({
        "name": dataSet.info.query[0],
        "children": [],
        // "category": "blank",
        // "color": am4core.color(CATEGORY_COLOR_SET["blank"])
      })

      dataSet.relation.forEach((item) => {
        let childrenList = [];

        for(let i = 0; i < item.content.length; i++){
          childrenList.push({
            "name": item.content[i].word,
            "value": item.content[i].freq,
            "category": item.category,
            "color": am4core.color(CATEGORY_COLOR_SET[item.category])
          })
          if( i+1 == maxNode) break;
        }

        retDataSet[0]['children'].push({
          "name": item.category,
          "color": CATEGORY_COLOR_SET[item.category],
          "children": childrenList
        })
      })

      break;
    }
    case "categoryMap": {
      let relationWordList = [];
      retDataSet.push({
        "name": dataSet['keyword'],
        "children": [],
        "category": dataSet['keyword-category'],
        "color": am4core.color(CATEGORY_COLOR_SET[dataSet['keyword-category']])
      })

      CATEGORY_SET.forEach((item)=>{
        retDataSet[0]['children'].push({
          "name": item,
          "color": CATEGORY_COLOR_SET[item],
          "children": []
        })
      })

      dataSet['relation-list'].forEach((item)=>{
        relationWordList.push({
          "name": item['relation-word'],
          "value": item['relation-frequency'],
          "category": item['relation-category'],
          "color": am4core.color(CATEGORY_COLOR_SET[item['relation-category']])
        })
      })

      retDataSet[0]['children'].forEach((item)=>{
        item['children'] = relationWordList.filter(relationItem=>relationItem['category']==item['name'])
      })

      let filtered_children = retDataSet[0]['children'].filter(item=>item['children'].length!=0);
      retDataSet[0]['children'] = filtered_children;

      break;
    }
    case "report-line": {
      dataSet.forEach(
        (item)=>{
          retDataSet.push({
            "date": item['date'],
            "community-value": item['community-frequency'],
            "news-value": item['news-frequency'],
            "twit-value": item['twit-frequency'],
            "club-value": item['club-frequency'],
            // "etc-value": item['etc-frequency'],
            "sum-value": item['sum-frequency']  
          })
        }
      )
      break;
    }
    case "quick-result-line": {
      let start_date = new Date(dataSet.dateRange[0].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'));
      let end_date = new Date(dataSet.dateRange[1].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'));
      let diff_date = (end_date.getTime() - start_date.getTime())/(1000*60*60*24);
      let pushDate = new Date(start_date);
      for (let i = 0; i < diff_date+1; i++) {
        retDataSet.push({
          "date": pushDate.toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}).replace(/\//g, "-"),
        })
        retDataSet[i]['news-value'] = 0;
        retDataSet[i]['blog-value'] = 0;
        // retDataSet[i]['twit-value'] = 0;
        // retDataSet[i]['club-value'] = 0;
        // retDataSet[i]['community-value'] = 0;
        retDataSet[i]['sum-value'] = 0;
        pushDate.setDate(pushDate.getDate()+1);
      }

      dataSet.basic.result.forEach(
        (item)=>{
          switch (item.channel) {
            case "news": {
              item.count.forEach((dailyItem)=>{
                retDataSet.filter((retDataItem)=>retDataItem.date.replace(/\-/g, "") == dailyItem.day).forEach((filteredItem)=>{
                  filteredItem['news-value'] += dailyItem.count;
                  filteredItem['sum-value'] += dailyItem.count;
                })
              })
              break;
            }
            case "blog0": {
              item.count.forEach((dailyItem)=>{
                retDataSet.filter((retDataItem)=>retDataItem.date.replace(/\-/g, "") == dailyItem.day).forEach((filteredItem)=>{
                  filteredItem['blog-value'] += dailyItem.count;
                  filteredItem['sum-value'] += dailyItem.count;
                })
              })
              break;
            }
            // case "twit1": {
            //   item.count.forEach((dailyItem)=>{
            //     retDataSet.filter((retDataItem)=>retDataItem.date.replace(/\-/g, "") == dailyItem.day).forEach((filteredItem)=>{
            //       filteredItem['twit-value'] += dailyItem.count;
            //       filteredItem['sum-value'] += dailyItem.count;
            //     })
            //   })
            //   break;
            // }
            // case "club0": {
            //   item.count.forEach((dailyItem)=>{
            //     retDataSet.filter((retDataItem)=>retDataItem.date.replace(/\-/g, "") == dailyItem.day).forEach((filteredItem)=>{
            //       filteredItem['club-value'] += dailyItem.count;
            //       filteredItem['sum-value'] += dailyItem.count;
            //     })
            //   })
            //   break;
            // }
            // case "board0": {
            //   item.count.forEach((dailyItem)=>{
            //     retDataSet.filter((retDataItem)=>retDataItem.date.replace(/\-/g, "") == dailyItem.day).forEach((filteredItem)=>{
            //       filteredItem['community-value'] += dailyItem.count;
            //       filteredItem['sum-value'] += dailyItem.count;
            //     })
            //   })
            //   break;
            // }
            default:
              break;
          }
        }
      )
      break;
    }
    // 2023.03.14
    // case "line": {
    //   dataSet['keyword-frequency-list'].forEach(
    //     (item)=>{
    //       retDataSet.push({
    //         "date": item['date'],
    //         "community-value": item['community-frequency'],
    //         "news-value": item['news-frequency'],
    //         "twit-value": item['twit-frequency'],
    //         "club-value": item['club-frequency'],
    //         // "etc-value": item['etc-frequency'],
    //         "sum-value": item['sum-frequency']  
    //       })
    //     }
    //   )
    //   break;
    // }
    case "quick-line": {
      dataSet['keyword-frequency-list'].forEach(
        (item)=>{
          retDataSet.push({
            "date": item['date'],
            "news-value": item['news-frequency'],
            // "twit-value": item['twit-frequency'],
            "blog-value": item['blog-frequency'],
            // "etc-value": item['etc-frequency'],
            "sum-value": item['sum-frequency']  
          })
        }
      )
      break;
    }
    case "horizontalBar": {
      dataSet['relation-list'].forEach((item)=>{
        retDataSet.push({
          'relationWord': item['relation-word'],
          'relationWordFrequency': item['relation-frequency'],
          'category': item['relation-category'],
          'color': am4core.color(CATEGORY_COLOR_SET[item['relation-category']])
        })
      })
      retDataSet.sort(function(a,b){
        return a['relationWordFrequency']-b['relationWordFrequency'];
      }) 
      dataSet['relation-list'].forEach((item,index)=>{
        retDataSet[index]['remainderFrequency'] = retDataSet[dataSet['relation-list'].length-1]['relationWordFrequency'] - retDataSet[index]['relationWordFrequency'];
      })
      break;
    }
    case "quick-result-sentimentBar": {
      let sentimentList = [];
      dataSet.sentiment.forEach((item)=>{
        sentimentList.push({
          "date": item['date'].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'),
          "positive": item['positive']['freq'],
          "negative": item['negative']['freq'],
          // "neutral": item['neutral']['freq'],
          "mix": item['mix']['freq']
        })
      })

      retDataSet={
        keyword: dataSet.info.query[0],
        sentiment: sentimentList
      }
      break;
    }
    case "sentimentBar": {
      let sentimentList = [];
      dataSet.sentiment.forEach((item)=>{
        sentimentList.push({
          "date": item['date'].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3'),
          "positive": item['positive'],
          "negative": item['negative'],
          "neutral": item['neutral'],
          "mix": item['mix']
        })
      })

      retDataSet={
        keyword: dataSet.keyword,
        sentiment: sentimentList
      }
      break;
    }
    case "quick-result-sentimentPie": {
      let totalPositive=0, totalNegative=0, totalNeutral=0, totalMix=0, totalValue=0;
      dataSet.sentiment.forEach((item)=> {
        totalPositive = totalPositive + item['positive']['freq'];
        totalNegative = totalNegative + item['negative']['freq'];
        // totalNeutral = totalNeutral + item['neutral']['freq'];
        totalMix = totalMix + item['mix']['freq'];
        // totalValue = totalValue + item['total'];
      })

      retDataSet={
        keyword: dataSet.info.query[0],
        sentiment: [
          {
            "sentiment": "긍정",
            "value": totalPositive,
            "color": am4core.color(SENTIMENT_COLOR_SET['positive'])
          },
          {
            "sentiment": "부정",
            "value": totalNegative,
            "color": am4core.color(SENTIMENT_COLOR_SET['negative'])
          },
          // {
          //   "sentiment": "중립",
          //   "value": totalNeutral,
          //   "color": am4core.color(SENTIMENT_COLOR_SET['neutral'])
          // },
          {
            "sentiment": "혼합",
            "value": totalMix,
            "color": am4core.color(SENTIMENT_COLOR_SET['mix'])
          }
        ]
      };
      break;
    }
    case "sentimentPie": {
      let totalPositive=0, totalNegative=0, totalNeutral=0, totalMix=0, totalValue=0;
      dataSet.sentiment.forEach((item)=> {
        totalPositive = totalPositive + item['positive'];
        totalNegative = totalNegative + item['negative'];
        totalNeutral = totalNeutral + item['neutral'];
        totalMix = totalMix + item['mix'];
        totalValue = totalValue + item['total'];
      })

      retDataSet={
        keyword: dataSet.keyword,
        sentiment: [
          {
            "sentiment": "긍정",
            "value": totalPositive,
            "color": am4core.color(SENTIMENT_COLOR_SET['positive'])
          },
          {
            "sentiment": "부정",
            "value": totalNegative,
            "color": am4core.color(SENTIMENT_COLOR_SET['negative'])
          },
          {
            "sentiment": "중립",
            "value": totalNeutral,
            "color": am4core.color(SENTIMENT_COLOR_SET['neutral'])
          },
          {
            "sentiment": "혼합",
            "value": totalMix,
            "color": am4core.color(SENTIMENT_COLOR_SET['mix'])
          }
        ]
      };
      break;
    }
    default: {
      break;
    }
  }
  // console.log(retDataSet);
  return retDataSet;
}

export default JSONtoChartData;